import React, { useState } from 'react';
import { authAPI } from '../services/api';
import Seo from '../components/Seo';

export default function Security() {
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      return setError('Please fill all password fields.');
    }
    if (form.newPassword !== form.confirmPassword) {
      return setError('New passwords and Confirm New password do not match.');
    }
    if (form.newPassword.length < 6) {
      return setError('New password must be at least 6 characters long.');
    }

    setSaving(true);
    try {
      const res = await authAPI.changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      if (res.data.success) {
        setMessage('Password updated successfully.');
        setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <Seo title="Security & Password - Kanjusee" />
      <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 26, fontWeight: 700, color: 'var(--char)', marginBottom: 24 }}>
        Security Settings
      </h1>

      <div className="card">
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>Change Password</h2>

        {message && <div style={{ background: '#ecfdf5', color: '#065f46', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{message}</div>}
        {error && <div style={{ background: '#fef2f2', color: '#991b1b', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}

        <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label className="form-label">Current Password</label>
            <input
              type="password"
              className="form-input"
              value={form.currentPassword}
              onChange={(e) => setForm(p => ({ ...p, currentPassword: e.target.value }))}
              required
            />
          </div>
          <div>
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              value={form.newPassword}
              onChange={(e) => setForm(p => ({ ...p, newPassword: e.target.value }))}
              required
            />
          </div>
          <div>
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-input"
              value={form.confirmPassword}
              onChange={(e) => setForm(p => ({ ...p, confirmPassword: e.target.value }))}
              required
            />
          </div>

          <div style={{ marginTop: 8 }}>
            <button
              type="submit"
              disabled={saving}
              style={{
                background: 'var(--green)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: 14,
                fontWeight: 700,
                cursor: saving ? 'not-allowed' : 'pointer',
                opacity: saving ? 0.7 : 1
              }}
            >
              {saving ? 'Saving...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
